import t from "../../../helpers/t";
import React from "react";
import { $, DropdownButton, Dropdown } from "../../../../../vendor";
import { rbac } from "../../pricetariffs";
import PricetariffValidFromsPanel from "./PricetariffvalidFromsPanel";
import { priceTariffsActions } from "inbooma-api";
import { Biscuit } from "../../../../utils";

const PricetariffItem = (props) => {
  const toggleValidFroms = (ev, id) => {
    const el = ev.currentTarget;
    const key = el.getAttribute("data-inb-toggle");
    $("#" + key).toggleClass("Dropdownactive");
    $("#row_" + id).toggleClass("toggled");
  };

  const onRemovePricetariff = (pricetariff) => {
    if (confirm(t("really_remove"))) {
      props.dispatch(
        priceTariffsActions.deletePricetariff({
          id: Number(pricetariff.id),
          token: Biscuit.get("token"),
        }),
      );
    }
  };
  return (
    <>
      <div
        className="inb-c-item inb-c-item--order row"
        key={props.pricetariff.id}
        id={"row_" + props.pricetariff.id}
        style={{ margin: "1rem 0" }}
      >
        <aside className="inb-c-item__actions">
          <DropdownButton
            id="dropdown-basic-button"
            title="..."
            drop="right"
            menuAlign="right"
            bsPrefix="button round inb-toggle-contingent-dd hover"
          >
            <ul className="inb-dropdown__list">
              {/* <li>
                                    <Dropdown.Item href={"/pricetariffs/" + props.pricetariff.id + "/returnTo/product_" + props.product.id}>
                                        <i className="fi fi-wrench"></i>{t('edit', null, ' capital')}
                                    </Dropdown.Item>
                                </li>*/}
              <li>
                <Dropdown.Item href="#" onClick={() => onRemovePricetariff(props.pricetariff)}>
                  <i className="fi fi-trash"></i>
                  {t("remove", null, " capital")}
                </Dropdown.Item>
              </li>
            </ul>
          </DropdownButton>
          <button
            className={
              "button round inb-toggle-details inb-toggle-details-" + Biscuit.get("user.client_id")
            }
            type="button"
            title={t("toggle_${a}", { a: t("pricetariff_valid_froms") }, "capital")}
            data-inb-toggle={"pricetariffs-panel-" + props.pricetariff.id}
            onClick={(e) => toggleValidFroms(e, props.pricetariff.id)}
            id={"btn_pt_" + props.pricetariff.id}
          >
            <i className="fi fi-list-thumbnails"></i>
            {props.pricetariff.pricetariff_valid_froms.length >= 1 && (
              <div class="badge primary reservations-count">
                {props.pricetariff.pricetariff_valid_froms.length}
              </div>
            )}
          </button>
        </aside>
        <div className="medium-offset-0 column medium-1 small-4 " title={"ID"}>
          {props.pricetariff.id}
        </div>
        <div className="medium-offset-0 column medium-4 small-8 " title={t("name")}>
          {props.pricetariff.name}
        </div>
        <div className="medium-offset-0 column medium-7 small-12 " title={t("description")}>
          {props.pricetariff.description}
        </div>
        <PricetariffValidFromsPanel
          validFroms={props.pricetariff.pricetariff_valid_froms}
          dispatch={props.dispatch}
          pricetariff={props.pricetariff}
          product={props.product}
        ></PricetariffValidFromsPanel>
        <div className="inb-contingent-progress">
          <div
            className={"progress beautify beautify-" + Biscuit.get("user.client_id")}
            role="progressbar"
            tabIndex="0"
            aria-valuenow="50"
            aria-valuemin="0"
            aria-valuetext="50 percent"
            aria-valuemax="100"
          >
            <div className="progress-bars"></div>
            <p className="progress-meter-text">
              {t("${a}_prices", { a: props.pricetariff.count_of_prices }, "capital")}
              <i className="hide set-resources-amount fi fi-pencil" data-inb-action-link="edit"></i>
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default PricetariffItem;
